import React from 'react';

/**
 * StatCard — an icon chip + label + value summary tile.
 * `tone` colors the icon chip. Used by the Manager dashboard summary row.
 */
const TONES = {
    blue: { chip: 'bg-blue-100 dark:bg-blue-900/30', icon: 'text-blue-600 dark:text-blue-400' },
    purple: { chip: 'bg-purple-100 dark:bg-purple-900/30', icon: 'text-purple-600 dark:text-purple-400' },
    orange: { chip: 'bg-orange-100 dark:bg-orange-900/30', icon: 'text-orange-600 dark:text-orange-400' },
    green: { chip: 'bg-brand-100 dark:bg-brand-900/30', icon: 'text-brand-700 dark:text-brand-400' },
    brand: { chip: 'bg-brand-100 dark:bg-brand-900/30', icon: 'text-brand-600 dark:text-brand-400' },
    gray: { chip: 'bg-slate-100 dark:bg-slate-700', icon: 'text-slate-500 dark:text-slate-400' },
};

export default function StatCard({ icon: Icon, title, value, tone = 'brand', className = '' }) {
    const t = TONES[tone] || TONES.brand;
    return (
        <div className={`bg-white dark:bg-slate-800 rounded-xl shadow-card p-6 flex items-center space-x-4 border border-slate-200 dark:border-slate-700 ${className}`}>
            <div className={`p-3 rounded-full ${t.chip}`}>
                <Icon className={`h-8 w-8 ${t.icon}`} />
            </div>
            <div>
                <p className="text-sm font-medium text-slate-500 dark:text-slate-400">{title}</p>
                <p className="text-2xl font-bold text-slate-900 dark:text-white tabular-nums">{value}</p>
            </div>
        </div>
    );
}
